import { Outlet, ScrollRestoration } from "react-router-dom"
import { useForceLayoutOnBlur } from "~/hooks/use-force-layout-on-blur"

export const RootLayout = () => {
  useForceLayoutOnBlur()

  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  )
}
